<mat-select [(value)]="this.language" class="reverse-icon-place big-picker" (selectionChange)="onLangChange()">
  <mat-option *ngFor="let lang of languages" value="{{ lang.value }}">
    {{ lang.text }}
  </mat-option>
</mat-select>
